/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface IShowPurchaseOrderInfoInput {
    canEdit: boolean;
    purchaseOrder: string;
    resources: {
        purchaseOrderLabel: string;
        editBtnLabel: string;
        purchaseOrderErrortext: string;
    };
    onEdit(): void;
}

export interface IShowPurchaseOrderInfo {
    showInfoProps: INodeProps;
    purchaseOrder: React.ReactNode;
    label: React.ReactNode;
}

const getPurchaseOrderInfo = ({
    canEdit,
    purchaseOrder,
    resources: { editBtnLabel, purchaseOrderLabel, purchaseOrderErrortext },
    onEdit
}: IShowPurchaseOrderInfoInput): IShowPurchaseOrderInfo => ({
    showInfoProps: { className: 'ms-checkout-guest-profile__selected-item' },
    label: (
        <label id='ms-checkout-guest-profile__label' className='ms-checkout-guest-profile__input-label'>
            {purchaseOrderLabel}
        </label>
    ),
    purchaseOrder: (
        <span className='ms-checkout-guest-profile__selected-po'>{purchaseOrder === '' ? purchaseOrderErrortext : purchaseOrder}</span>
    )
});

export default getPurchaseOrderInfo;
